export var radii = {
    md: '3px',
};
